// extracted by css-extract-rspack-plugin
export default {"StaticDiffPreview":"StaticUnifiedDiffPreview-module__StaticDiffPreview__aEqrDPB","HeaderContainer":"StaticUnifiedDiffPreview-module__HeaderContainer__iTtofvm"};